import useContact from '../hooks/useContact';
import { trackPixel } from '../lib/pixel';

export default function FloatingButtons() {
  const { whatsappLink, callLink, phone, facebookUrl } = useContact();
  return (
    <div className="fixed bottom-6 right-6 z-50 flex flex-col gap-3">
    {/* Facebook Button */}
      <a
        href={facebookUrl}
        onClick={() => trackPixel('Contact', { method: 'facebook' })}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="facebook-btn"
        aria-label="Follow on Facebook"
        className="flex items-center justify-center w-14 h-14 rounded-full shadow-2xl transition-all duration-300 hover:scale-110"
        style={{ backgroundColor: '#1877F2' }}
      >
        <svg viewBox="0 0 24 24" width="22" height="22" fill="white">
          <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
        </svg>
      </a>

      {/* WhatsApp Button */}
      <a
        href={whatsappLink}
        onClick={() => trackPixel('Contact', { method: 'whatsapp' })}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="whatsapp-btn"
        aria-label="Chat on WhatsApp"
        className="flex items-center justify-center w-14 h-14 rounded-full shadow-2xl transition-all duration-300 hover:scale-110 hover:shadow-green-400/50"
        style={{ backgroundColor: '#25D366' }}
      >
        <svg viewBox="0 0 32 32" width="28" height="28" fill="white">
          <path d="M16.004 2.667C8.636 2.667 2.667 8.636 2.667 16c0 2.347.618 4.572 1.7 6.512L2.667 29.333l6.987-1.671A13.28 13.28 0 0016.004 29.333c7.364 0 13.33-5.969 13.33-13.333S23.368 2.667 16.004 2.667zm7.32 18.347c-.303.856-1.785 1.63-2.45 1.736-.623.099-1.41.14-2.278-.143-.524-.172-1.197-.4-2.057-.784-3.617-1.56-5.976-5.198-6.155-5.439-.179-.241-1.459-1.939-1.459-3.698 0-1.758.921-2.624 1.247-2.979a1.31 1.31 0 01.95-.446c.237 0 .474.004.681.014.218.011.51-.083.8.61.303.714 1.032 2.472 1.122 2.651.09.179.148.387.03.624-.12.237-.18.384-.357.593-.179.21-.375.469-.535.63-.179.179-.366.374-.157.733.208.359.928 1.53 1.992 2.477 1.368 1.22 2.522 1.598 2.879 1.778.357.179.565.149.773-.09.208-.24.892-1.039 1.13-1.398.238-.358.476-.298.802-.179.327.12 2.075.978 2.43 1.155.357.179.595.268.683.417.09.147.09.854-.213 1.709z"/>
        </svg>
      </a>

      {/* Call Button */}
      <a
        href={callLink}
        onClick={() => trackPixel('Contact', { method: 'phone_call' })}
        data-testid="call-btn"
        aria-label={`Call us at ${phone}`}
        className="flex items-center justify-center w-14 h-14 rounded-full shadow-2xl transition-all duration-300 hover:scale-110 hover:shadow-blue-400/50"
        style={{ backgroundColor: '#3B82F6' }}
      >
        <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
          <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 10.8a19.79 19.79 0 01-3.07-8.67A2 2 0 012 0h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.91 7.91a16 16 0 006.18 6.18l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z"/>
        </svg>
      </a>
    </div>
  );
}
